import vCard from "../lib/vcard.js";
import * as modal from "../util/modal.ts";
import {forInputDate} from "../lib/DateUtils.ts";
import { downloadUrl } from "../lib/FileUtils.ts";
export {share,download}

async function getVCardAsBlob(contact: any): Promise<Blob> {
  var
      contactCard = vCard.create(vCard.Version.FOUR)

    contactCard.add(vCard.Entry.FORMATTEDNAME, contact.displayName)
    if(contact.function){
      contactCard.add(vCard.Entry.TITLE, contact.function)
    }
    if(contact.firstName){
      contactCard.add(vCard.Entry.NAME, [contact.lastName,contact.firstName,'',''].map((it: any)=>it?it:'').join(';'))
    }
    if(contact.birthDate){
      contactCard.add(vCard.Entry.BIRTHDAY,forInputDate(contact.birthDate))
    }

    contact.devices.forEach((device: any)=>{
      if(device.deviceType==='MOBILE'){
        contactCard.add(vCard.Entry.PHONE, device.value, vCard.Type.CELL)
      }else if(device.deviceType==="PHONE_WORK"){
        contactCard.add(vCard.Entry.PHONE, device.value, vCard.Type.WORK)
      }else if(device.deviceType==="PHONE_HOME"){
        contactCard.add(vCard.Entry.PHONE, device.value, vCard.Type.HOME)
      }else if(device.deviceType==='EMAIL'){
        contactCard.add(vCard.Entry.EMAIL, device.value, vCard.Type.WORK)
      }
    })
    contact.addresses.forEach((address: any)=>{
      if(address.placeType==='HOME'){
        contactCard.add(vCard.Entry.ADDRESS, address.geocodedAddress.formattedAddress, vCard.Type.HOME)
      }else if(address.placeType==='WORK'){
        contactCard.add(vCard.Entry.ADDRESS, address.geocodedAddress.formattedAddress, vCard.Type.WORK)
      }
    })
    //contactCard.add(vCard.Entry.ORGANIZATION, "JohnDoe Corp.")
    //johnDoe.add(vCard.Entry.ADDRESS, ";;street;city;state;zip code;country", vCard.Type.HOME)
    //console.log(vCard.dump(contactCard))

    return fetch(contact.thumb()).then((thumb: Response)=>{
      return thumb.body!.getReader().read()
    }).then(({ done, value }: any)=>{
      var base64 = btoa(String.fromCharCode.apply(null, Array.from(value)))
      contactCard.add(vCard.Entry.PHOTO, base64, "JPEG;ENCODING=BASE64")
    }).catch((e: any)=>{
      console.log(e);
      return contactCard;
    }).then((t: any)=>{
      return new Blob([vCard.dump(contactCard)], {"type": "text/vcard"})
    })
}

async function share(contact: any): Promise<any> {
  try{
    var blob = await getVCardAsBlob(contact)
    //FIXME .vcf text/vcard files are not suppoorted yet by sharing
    //and navigator.canShare does not respond with false so...
    return await navigator.share({text:contact.displayName,files:[new File([blob],contact.displayName+'.vcf',{type:'text/vcard'})]})

  }catch(e){
    modal.oops('fw2.defaultError')
  }

}

async function download(contact: any): Promise<void> {
  return getVCardAsBlob(contact).then((blob: Blob)=>{
    downloadUrl(URL.createObjectURL(blob),contact.displayName+'.vcf')
  })
}

